export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  // A third segment on the mode toggle. Unlike the other two it is not a
  // composer mode: it swaps the composer for the reminder panel and never
  // becomes the conversation's replyType, so drafts and reply permissions
  // are untouched by it.
  REMINDER: 'REMINDER',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
